import { selectAll } from 'd3';

export const tooltipClassName = 'cvtooltip';
export function removeAllTooltips() {
    selectAll(`.${tooltipClassName}`).remove();
}